export const houseTypeDetail = {
  detail: '户型详情',
  house:"户",
  type:"型 ：", 
  area: '建筑面积 ：',
  inner: '套内面积 ：',
  address: '楼盘地址 ：',
  price: '楼盘均价 ：',
  unit: '元/㎡',
  relevant: '相关优秀案例'
};
